import apiService from './api';

// Use the exported axios instance directly
export const getInvoices = (params) => apiService.invoices.getAll(params);
export const getInvoice = (id) => apiService.invoices.getById(id);
export const createInvoice = (data) => apiService.invoices.create(data);
export const updateInvoice = (id, data) => apiService.invoices.update(id, data);
export const deleteInvoice = (id) => apiService.invoices.delete(id);
export const downloadInvoicePDF = (id) => apiService.invoices.downloadPDF(id);
export const markInvoicePaid = (id) => apiService.invoices.markPaid(id);
